export default __webpack_public_path__ + "static/media/person_3@3x.780f3675.png";